import { Button } from 'primereact/button';
import { containsVirtualItems } from 'utils/cartUtils';
import { CustomerOption } from 'components/Checkout';
import { ReactElement, useState } from 'react';
import ReactGA from 'react-ga4';
import { useAuth0 } from '@auth0/auth0-react';
import { useCartContext } from 'CartContext';
import { useLogin, useLogout } from 'hooks/userHooks';

export interface CheckoutAccountProps {
  setClickNeedsHandling: (needsHandling: boolean) => void;
  newCustomerOption: CustomerOption;
  setNewCustomerOption: (option: CustomerOption) => void;
}

export default function CheckoutAccount(
  props: CheckoutAccountProps,
): ReactElement {
  const { setClickNeedsHandling, newCustomerOption, setNewCustomerOption } =
    props;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [newCustomerOptionLocal, setNewCustomerOptionLocal] = useState(
    newCustomerOption === CustomerOption.login
      ? CustomerOption.registerAccount
      : newCustomerOption,
  );
  const login = useLogin();
  const logout = useLogout();
  const { isAuthenticated, user } = useAuth0();
  const { items } = useCartContext();
  const hasVirtualItems = containsVirtualItems(items);

  if (isAuthenticated) {
    return (
      <div className="my-4">
        <h2>Welcome!</h2>
        <p>
          You are logged in as {user?.email}.<br /> If you need to switch users,
          please logout and login with a new user.
        </p>
        <div className="flex flex-row">
          <Button
            className="uppercase border-noround c-button-primary"
            id="checkout-account"
            onClick={() => {
              setClickNeedsHandling(true);
              ReactGA.event({
                category: 'ecommerce',
                action: 'checkout_step_1',
                label: 'Checkout Step 1 - Account Complete',
              });
            }}
          >
            Continue
          </Button>
          <Button
            className="uppercase border-noround p-button-outlined p-button-secondary ml-4"
            onClick={() => {
              logout();
            }}
          >
            Logout
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="grid">
        <div className="col-12 flex flex-column align-items-start">
          <Button
            className="uppercase border-noround c-button-primary mt-4 mb-2"
            onClick={() => {
              setClickNeedsHandling(true);
              setNewCustomerOption(newCustomerOptionLocal);
              ReactGA.event({
                category: 'Checkout Step 1 - Account Complete',
                action: 'Checkout Step 1 - Account Complete',
                label: 'Checkout Step 1 - Account Complete',
              });
            }}
          >
            New Account
          </Button>
          {!hasVirtualItems && (
            <>
              <Button
                className="text-800 m-0 p-0 mb-6 underline"
                style={{ background: 'none', border: 'none' }}
                onClick={() => {
                  setNewCustomerOption(CustomerOption.guestCheckout);
                  setClickNeedsHandling(true);
                }}
              >
                Guest Checkout
              </Button>
            </>
          )}
          <Button
            className="uppercase border-noround c-button-primary mb-4"
            onClick={() => {
              setNewCustomerOption(CustomerOption.login);
              setClickNeedsHandling(true);
              login();
            }}
          >
            Returning Customer
          </Button>
        </div>
      </div>
    </div>
  );
}
